import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    WebView,
    ActivityIndicator, Linking,
    Text
} from "react-native";
import {connect} from "react-redux";
import HMActionBarSatia from "../../../customviews/HMActionBarSatia";

import HMDialogWifiCheck from "../../../customviews/HMDialogWifiCheck";

//import OfflineCacheWebView from 'react-native-offline-cache-webview';
let container = null;

class HotSpotScreen extends Component {

    constructor(props) {
        super(props);
        container = this
        this.state = {
            visible: true,
            scalesPageToFit: true,
        };
    }

    hideSpinner() {
        this.setState({visible: false});
    }

    componentWillReceiveProps(props) {

    }

    showDialogUpdateApp() {
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }

    state = {
        WifiCheck:false
    };



    render() {
       // let _params = this.props.route.params;
        //let _item = JSON.parse(_params.item);
        //let item = this.props.route && this.props.route.params ? _item : {}

        return (


            <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>

                <HMActionBarSatia
                    menu
                    props={this.props} statusBarTransparent
                    // text={i18n.t('ListNews.title')}
                    //text={i18n.t('ListNews.title')}
                    text={"هات اسپات"}

                    back
                    //  text={i18n.t('constant.Information')}

                    headerVisibility more_menu
                    onBackPress={() => this.props.navigation.pop()}

                />
                <View style={{flex: 1}}>


                    <HMDialogWifiCheck onPressCancel={() => {
                        this.setState({
                            WifiCheck: false
                        })
                    }} func={null
                        //this.checkMobile
                    }/>

                </View>
            </KeyboardAvoidingView>

        );
    }

}

const mapStateToProps = state => {
    return {
        // data: state.reducerSplashGetAllData,
        // NoInternetDialogSet: state.reducerMenuScreen.NoInternetDialogSet,
        // showLoadingSet: state.reducerMenuScreen.showLoadingSet,
        // resultsSetCommentScreen: state.reducerMenuScreen.resultsSetCommentScreen,
        // token: state.reducerSplashGetAllData.token,
        // DataSplashScreen: state.reducerSplashGetAllData,

    };
};
const styles = StyleSheet.create({
    WebViewStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        marginTop: 40,
    },
    ActivityIndicatorStyle: {
        flex: 1,
        justifyContent: 'center',
    },
});
const mapDispatchToProps = dispatch => {
    return {
        //    callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HotSpotScreen);
